import React, { useEffect, useRef } from "react";

const CursorGlow = () => {
  const dotRef = useRef(null);
  const glowRef = useRef(null);
  const glowPos = useRef({ x: -300, y: -300 });
  const targetPos = useRef({ x: -300, y: -300 });
  const rafRef = useRef(null);

  useEffect(() => {
    // Dot updates INSTANTLY via direct DOM style — zero React re-render lag
    const handleMouseMove = (e) => {
      targetPos.current = { x: e.clientX, y: e.clientY };
      if (dotRef.current) {
        dotRef.current.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
      }
    };

    // Interactive elements: expand cursor dot
    const onEnter = () => {
      if (!dotRef.current) return;
      dotRef.current.style.width = "22px";
      dotRef.current.style.height = "22px";
      dotRef.current.style.background = "transparent";
      dotRef.current.style.border = "1.5px solid #D4AF37";
      dotRef.current.style.opacity = "0.9";
    };
    const onLeave = () => {
      if (!dotRef.current) return;
      dotRef.current.style.width = "7px";
      dotRef.current.style.height = "7px";
      dotRef.current.style.background = "#D4AF37";
      dotRef.current.style.border = "none";
      dotRef.current.style.opacity = "0.85";
    };

    // Smooth lerp glow via requestAnimationFrame
    const animateGlow = () => {
      const lerp = 0.07;
      glowPos.current.x += (targetPos.current.x - glowPos.current.x) * lerp;
      glowPos.current.y += (targetPos.current.y - glowPos.current.y) * lerp;
      if (glowRef.current) {
        glowRef.current.style.transform = `translate(${glowPos.current.x - 200}px, ${glowPos.current.y - 200}px)`;
      }
      rafRef.current = requestAnimationFrame(animateGlow);
    };

    rafRef.current = requestAnimationFrame(animateGlow);
    window.addEventListener("mousemove", handleMouseMove, { passive: true });

    // Observe DOM for dynamically added interactive elements
    const attachHoverListeners = () => {
      document.querySelectorAll("a, button, [role='button'], input, select, label, textarea").forEach((el) => {
        if (!el.dataset.cursorBound) {
          el.addEventListener("mouseenter", onEnter);
          el.addEventListener("mouseleave", onLeave);
          el.dataset.cursorBound = "1";
        }
      });
    };
    attachHoverListeners();
    const observer = new MutationObserver(attachHoverListeners);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      cancelAnimationFrame(rafRef.current);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      {/* Ambient gold glow — smooth lerp */}
      <div
        ref={glowRef}
        className="pointer-events-none fixed z-[9997] rounded-full will-change-transform"
        style={{
          width: 400,
          height: 400,
          top: 0,
          left: 0,
          background: "radial-gradient(circle, rgba(212,175,55,0.06) 0%, transparent 65%)",
          transform: "translate(-300px, -300px)",
        }}
      />
      {/* Cursor dot — INSTANT direct DOM update, no React state */}
      <div
        ref={dotRef}
        className="pointer-events-none fixed z-[9999] rounded-full will-change-transform"
        style={{
          width: 7,
          height: 7,
          top: 0,
          left: 0,
          marginLeft: "-3.5px",
          marginTop: "-3.5px",
          background: "#D4AF37",
          opacity: 0.85,
          transform: "translate(-300px, -300px)",
          transition: "width 0.18s ease, height 0.18s ease, background 0.18s ease, border 0.18s ease, opacity 0.18s ease",
        }}
      />
    </>
  );
};

export default CursorGlow;
